import * as angular from 'angular';
import template from './resetPassword.tpl.html'
import { States } from "../../shared/config/constant.module";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import { StateParams } from "../../common";
import ResetPasswordServiceName, { ResetPasswordByEmailPayload, ResetPasswordService }
  from "../../services/resetPassword/resetPassword.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";

let requires = [LoaderServiceName, ResetPasswordServiceName, NotifyServiceName];

interface ResetPasswordParams extends StateParams {
  token: string;
}

interface ResetPasswordController {
  form: angular.IFormController;
  password: string;
  confirmPassword: string;
  setPassword: () => void;
}

export default angular.module('aps.controller.resetPassword', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.RESET_PASSWORD,
      url: '/resetPassword?userId&token',
      controller: 'ResetPasswordCtrl as resetPasswordCtrl',
      template: template,
      data: { pageTitle: 'Reset Password' }
    });
  })
  .controller('ResetPasswordCtrl', resetPasswordCtrl)
  .name;

function resetPasswordCtrl(
  loaderService: LoaderService,
  $stateParams: ResetPasswordParams,
  resetPasswordService: ResetPasswordService,
  $state: angular.ui.IStateService,
  notifyService: NotifyService
) {
  let vm = this as ResetPasswordController;

  let submitSuccess = function () {
    notifyService.success('Password changed. You may now sign in!');
    $state.go(States.SIGN_IN);
  };

  vm.setPassword = function () {
    if (vm.form.$invalid) {
      return;
    }

    let submission: ResetPasswordByEmailPayload = {
      userId: $stateParams.userId,
      token: $stateParams.token,
      password: vm.password,
      confirmPassword: vm.confirmPassword
    };
    loaderService.loadingPromise(
      resetPasswordService.submitEmailPasswordReset(submission)
        .then(submitSuccess, notifyService.handleApiErrors));
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/resetPassword/resetPassword.controller.ts